import {
  ForgotPasswordPayload,
  LoginPayload,
  LoginResponse,
} from "../../../../models/User";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function forgotPassword(data: ForgotPasswordPayload) {
  const res = await ApiClient.post(`/ForgotPassword`, data);
  return res.data;
}

export const useForgotPassword = mutationWrapper(forgotPassword);
